import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import React from "react";
import styled from "styled-components";
import { colors } from "../../../../../utils/colors";
import { IconAction } from "../../../../atoms/IconAction";
import { LocationLanguageButtons } from "../../../../molecules/LocationLanguageButtons";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 75px;
    background-color: ${colors.brandDark};
    padding: 0 22px;
`;

export const MobileMenuHeader = (props: { onClose: () => void }) => {
    return (
        <Wrapper>
            <LocationLanguageButtons showRegion suburbCondition />
            <IconAction icon={<CloseRoundedIcon />} onClick={props.onClose}>
                Close
            </IconAction>
        </Wrapper>
    );
};
